import {
  TRUNCATE_MAX,
  isTruncatedString,
  truncateString,
} from '../../utils/truncateString';
import { BaseTooltip } from '../BaseTooltip';
import {
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbText,
  Navigation,
} from './styles';

interface IBreadcrumbsProps {
  links: Array<{ name: string; url: string }> | null;
  onClick: (index: number) => void;
}

export const BreadcrumbsComponent = ({
  links,
  onClick,
}: IBreadcrumbsProps): JSX.Element => {
  const handleClick = (index: number) => {
    onClick(index);
  };

  return (
    <Navigation aria-label="breadcrumb" data-cy="breadcrumb">
      {links &&
        links.length > 0 &&
        links.map((link, index) => {
          const isLast = index === links.length - 1;
          const truncatedName = truncateString(
            link.name,
            TRUNCATE_MAX.BREADCRUMB
          );
          return (
            <BreadcrumbItem
              key={link.url}
              className={`breadcrumb-item ${isLast ? 'active' : ''}`}
              aria-current={isLast ? 'page' : undefined}
              data-cy={`breadcrumb-${index}`}
            >
              {isLast ? (
                <BaseTooltip
                  message={link.name}
                  disabled={
                    !isTruncatedString(link.name, TRUNCATE_MAX.BREADCRUMB)
                  }
                >
                  <BreadcrumbText>{truncatedName}</BreadcrumbText>
                </BaseTooltip>
              ) : (
                <BreadcrumbLink
                  to={link.url}
                  onClick={() => handleClick(index)}
                >
                  {truncatedName} {' > '}
                </BreadcrumbLink>
              )}
            </BreadcrumbItem>
          );
        })}
    </Navigation>
  );
};
